import React from 'react';

function Header() {

    return (
        <div className="container mx-auto">

            <header>
                <div className="bg-amber-400 flex flex-col justify-center items-center rounded-b-[25px] md:rounded-b-[30px] block lg:hidden py-10 px-5">

                    <h1 className="text-3xl font-semibold text-white">
                        Happy Taxi
                    </h1>

                    <p className="text-white text-center mt-4 md:text-sm">
                        Aplicación móvil que te ayuda a reservar tu viaje en taxi de forma rápida y eficiente
                    </p>

                    <div className="flex flex-row gap-x-3 mt-10">
                        <a href="#" className="bg-white rounded-full font-semibold text-gray-600 px-8 py-2  text-sm flex gap-x-2">
                            App Store
                        </a>

                        <a href="#" className="bg-white rounded-full font-semibold text-gray-600 px-8 py-2 text-sm flex gap-x-2 ">
                            Play Store
                        </a>
                    </div>
                </div>
            </header>

        </div>
    );
}

export default Header;